<template>
    <div class="FM_withdrawalList">
        <el-card class="box-card" shadow="hover">
<!--            <el-form :inline="true"  class="demo-form-inline">-->
<!--                <el-form-item>-->
<!--                <el-button size="medium" type="primary" style="font-size: 12px;" @click="show()">开始任务</el-button>-->
<!--                </el-form-item>-->
<!--            </el-form>-->


            <el-table :data="flow_back_list" border style="width:auto;margin-top:30px;font-size:12px" >
                <el-table-column fixed type="index" width="50" header-align="center" align="center"></el-table-column>
                <el-table-column prop="work_order" width="300" header-align="center" align="center" label="工单号"></el-table-column>
                <el-table-column prop="terminal_num" width="80" header-align="center" align="center" label="终端数量"></el-table-column>
<!--                <el-table-column prop="valid_start_date" header-align="center" align="center" label="开始时间"></el-table-column>-->
<!--                <el-table-column prop="valid_end_date" header-align="center" align="center" label="结束时间"></el-table-column>-->
<!--                <el-table-column prop="deduct_amount" header-align="center" align="center" label="交易金额"></el-table-column>-->
                <el-table-column prop="content" header-align="center" align="center" label="备注"></el-table-column>
                <el-table-column prop="create_time" header-align="center" align="center" label="创建时间"></el-table-column>
<!--                <el-table-column prop="update_time" header-align="center" align="center" label="更改时间"></el-table-column>-->
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page_box">
                <el-pagination background layout="total,sizes,prev, pager, next" :total="count" @current-change="nextPage" @size-change="handleSizeChange" :page-sizes="[10, 20, 30, 40]" :page-size="10"></el-pagination>
            </div>
        </el-card>



        <!--查看详细信息-->
        <div v-if="info_is_show" class="bg_show">
            <el-card class="box-card" shadow="hover" style="width:65%">
                <div class="hide"><i class="el-icon-close" @click="infoIsHide()"></i></div>
                <el-form :inline="true"  class="demo-form-inline">
                    <el-form-item><el-input size clearable v-model="search_info.terminal_sn"  placeholder="终端编号"></el-input></el-form-item>
<!--                    <el-form-item><el-input size clearable v-model="search_info.merchant_name"  placeholder="商户名称"></el-input></el-form-item>-->
                    <el-form-item><el-input size clearable v-model="search_info.merchant_number"  placeholder="商户编号"></el-input></el-form-item>
                    <el-form-item>
                        <el-select v-model="search_info.status" placeholder="状态">
                            <el-option label="待扣款" value="2"></el-option>
                            <el-option label="扣款成功" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item><el-date-picker v-model="search_info.valid_start_date" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择扣款开始日期时间"></el-date-picker></el-form-item>
                    <el-form-item><el-date-picker v-model="search_info.valid_end_date" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择扣款结束日期时间"></el-date-picker></el-form-item>
                    <el-form-item>
                        <el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;" @click="searchInfo()">查询</el-button>
                        <el-button size="medium" type="primary" style="font-size: 12px;" @click="excilExport()">导出</el-button>
                    </el-form-item>

                </el-form>
                <el-table :data="info_list" border height="500" style="width:100%;margin-top:30px;font-size:12px">
                    <el-table-column fixed type="index" width="50" header-align="center" align="center"></el-table-column>
<!--                    <el-table-column prop="work_order" width="230" header-align="center" align="center" label="工单号"></el-table-column>-->
                    <el-table-column prop="work_order"  header-align="center" align="center" label="上级信息">
                        <template scope="scope">
                            <p>{{name(scope)}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="phone" width="120" header-align="center" align="center" label="代理手机号"></el-table-column>
                    <el-table-column prop="terminal_sn" width="185" header-align="center" align="center" label="终端编号"></el-table-column>
<!--                    <el-table-column prop="deduct_type" width="185" header-align="center" align="center" label="扣款类型">-->
<!--                        <template scope="scope">-->
<!--                            <p v-if="scope.row.deduct_type==1">通信费扣款</p>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column prop="merchant_name" width="300" header-align="center" align="center" label="商户名称"></el-table-column>-->
                    <el-table-column prop="merchant_number" width="170" header-align="center" align="center" label="商户编号"></el-table-column>
<!--                    <el-table-column prop="valid_start_date" width="170" header-align="center" align="center" label="扣款开始时间"></el-table-column>-->
<!--                    <el-table-column prop="valid_end_date" width="170" header-align="center" align="center" label="扣款结束时间"></el-table-column>-->
                    <el-table-column prop="status" width="100" header-align="center" align="center" label="状态">
                        <template scope="scope">
<!--                            <p v-if="scope.row.status==1">未设置</p>-->
                            <p v-if="scope.row.status==2">待扣款</p>
                            <p v-if="scope.row.status==3">扣款成功</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deduct_time" width="170" header-align="center" align="center" label="扣款时间"></el-table-column>
<!--                    <el-table-column prop="create_time" width="170" header-align="center" align="center" label="创建时间"></el-table-column>-->
<!--                    <el-table-column prop="update_time" width="170" header-align="center" align="center" label="更改时间"></el-table-column>-->
                </el-table>
                <div class="page_box">
                    <el-pagination background layout="total,prev, pager, next" :total="info_count" @current-change="nextInfoPage" :page-size="10"></el-pagination>
                </div>
            </el-card>
        </div>


        <!--导入终端信息-->
        <div v-if="is_show" class="bg_show">
            <el-card class="box-card" shadow="hover" style="width:50%;">
                <div class="hide"><i class="el-icon-close" @click="hide()"></i></div>
                <el-form :inline="true"  class="demo-form-inline" style="margin-top:10px;display:flex;justify-content:center">
                    <el-form-item>
                        <div class="upload_box">
                            <div class="input_box">
                                <div class="upload_btn">导入数据</div>
                                <input class="upload" type="file" @change="importfxx(this)"  accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" />
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="tableToExcel" @click="tableToExcel()">下载模板</div>
                    </el-form-item>
                </el-form>

                <el-form :inline="true"  class="demo-form-inline" style="margin-top:25px;display:flex;justify-content:center">

                    <el-form-item><el-date-picker v-model="valid_start_date" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择任务开始日期时间"></el-date-picker></el-form-item>
                    <el-form-item><el-date-picker v-model="valid_end_date" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择任务结束日期时间"></el-date-picker></el-form-item>
                    <el-form-item><el-input size type="number" clearable v-model="deduct_amount"  placeholder="扣款金额"></el-input></el-form-item>
                </el-form>

                <el-form :inline="true"  class="demo-form-inline" style="margin-top:10px;display:flex;justify-content:center">
                    <el-form-item label="备注" style="font-weight:500"><el-input class="textarea" type="textarea" v-model="content"></el-input></el-form-item>
                </el-form>

                <div style="font-size:13px;color:#333;margin-top:20px">共计{{save_list.length}}条,成功{{success_sum}}条,<span style="color:red">失败{{fail_sum}}条</span></div>
                <el-table :data="save_list" border height="250" style="width:auto;margin-top:20px" >
                    <el-table-column type="index" width="50" label="" fixed header-align="center" align="center"></el-table-column>
                    <el-table-column prop="terminal_sn" label="终端编号" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="merchant_number" label="商户编号" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="status" width="80" label="状态" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="reason" label="导入失败原因" header-align="center" align="center"></el-table-column>
                </el-table>

                <div class="btn"><el-button @click="saveData()" type="primary">添加</el-button></div>
            </el-card>
        </div>

    </div>
</template>
<script type="text/javascript" src="https://www.jq22.com/demo/jqueryExcel201803131054/xlsx.core.min.js"></script>
<script>

    export default {
        components: { },
        name: "FM_list",
        data() {
            return {
                save_list: [],//输入终端设备信息
                valid_start_date:'',//扣款开始时间
                valid_end_date:'',//扣款结束时间
                deduct_amount:'',//输入扣款金额
                content:"",//备注
                is_show:false,//导入终端弹框
                fail_sum:0,//失败条数
                success_sum:0,//成功条数


                //查查看详情
                info_is_show:false,
                info_list:[],//详情列表
                info_count:0,//详情总数
                search_info:{
                    work_order:'',//工单号 必填
                    terminal_sn:'',//终端编号
                    merchant_name:'',//商户名称
                    merchant_number:'',//商户编号
                    status:'',//扣款状态
                    valid_start_date:'',//扣款时间
                    valid_end_date:'',//扣款结束时间
                    page:1,//分页
                    is_export:1,//是否为导出操作 1正常查询 2导出

                },//搜索条件

                work_order:'',//工单编号
                start_time:'',//开始时间
                end_time:'',//结束时间
                flow_back_list:[],//流量卡列表
                page:1,
                limit:10,
                count:0,

            }
        },

        mounted() {
            this.getFlowBackList()
        },

        methods: {
            //分页
            nextPage(res){
                this.page = res
                this.getFlowBackList()
            },
            //每页数量
            handleSizeChange(res){
                this.limit = res
                this.getFlowBackList()
            },
            //获取列表详情
            getFlowBackList(){
                var _this = this
                var obj = {
                    work_order:this.work_order,
                    valid_start_date:this.start_time,
                    valid_end_date:this.end_time,
                    page:this.page,
                    limit:this.limit,
                }
                this.$api.post("transaction_flow_back/get_flow_back_list",obj,res => {
                    if(res.code == 0){
                        _this.flow_back_list = res.data.list
                        _this.count = res.data.count
                    }
                })
            },

            /////////查看详细信息
            handleClick(res){
                this.search_info.work_order = res.work_order
                this.getFlowBackInfo()
                this.info_is_show = true
            },
            //详情分页
            nextInfoPage(res){
                this.search_info.page = res
                this.getFlowBackInfo()
            },
            //搜索
            searchInfo(){
                this.getFlowBackInfo()
            },
            //详情信息
            getFlowBackInfo(data = ''){
                if(data == 'is_export'){
                    this.search_info.is_export = 2
                }else{
                    this.search_info.is_export = 1
                }

                var _this = this

                this.$api.post("transaction_flow_back/get_flow_back_info",this.search_info,res => {
                    if(res.code == 0){
                        _this.info_list = res.data.list
                        _this.info_count = res.data.count
                        if(res.data.download !== undefined && res.data.download != false){
                            window.open('https://ydoss.wondpay.cn//'+res.data.download)
                        }
                    }
                })
            },
            infoIsHide(){
                this.info_is_show = false
                this.info_list = []
                this.work_order = '';
                this.search_info = {
                    work_order:'',//工单号 必填
                    terminal_sn:'',//终端编号
                    merchant_name:'',//商户名称
                    merchant_number:'',//商户编号
                    status:'',//扣款状态
                    valid_start_date:'',//扣款时间
                    valid_end_date:'',//扣款结束时间
                    page:1,//分页

                }
            },
            //导出详情
            excilExport(){
              //数据导出 传入数据证明是导出数据
                this.getFlowBackInfo('is_export')
            },
            name(res){
                return res.row.nickname + ','+res.row.uuu_name
            },


            ////////////////导入数据
            importfxx(e){
                var _this = this
                var files = event.currentTarget.files;
                e = event.currentTarget.files;
                //未选择文件
                if(e.length <= 0){
                    return false;
                }
                var fileReader = new FileReader();
                fileReader.onload = function(ev) {
                    try {
                        var data = ev.target.result,
                            workbook = XLSX.read(data, {
                                type: 'binary'
                            }), // 以二进制流方式读取得到整份excel表格对象
                            persons = []; // 存储获取到的数据
                    } catch (e) {
                        console.log('文件类型不正确');
                        return;
                    }

                    // 表格的表格范围，可用于判断表头是否数量是否正确
                    var fromTo = '';
                    // 遍历每张表读取
                    for (var sheet in workbook.Sheets) {
                        if (workbook.Sheets.hasOwnProperty(sheet)) {
                            fromTo = workbook.Sheets[sheet]['!ref'];

                            persons = persons.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                            break; // 如果只取第一张表，就取消注释这行
                        }
                    }

                    persons = JSON.stringify(persons)
                    persons = persons.replace(/终端sn/g, 'terminal_sn').replace(/店铺编号/g, 'merchant_number')
                    persons = JSON.parse(persons)

                    _this.save_list = persons

                    if(_this.save_list.length > 0){
                        //检测录入格式是否正确 不正确重新为空
                        if(_this.save_list[0].merchant_number == undefined || _this.save_list[0].terminal_sn == undefined){
                            _this.save_list = []
                            _this.$message.error('导入格式不正确');
                        }
                    }


                };
                // 以二进制方式打开文件
                fileReader.readAsBinaryString(files[0]);
            },
            //导入数据接口
            saveData(){
                var _this = this

                var obj = {
                    save_list:this.save_list,
                    valid_start_date:this.valid_start_date,
                    valid_end_date:this.valid_end_date,
                    deduct_amount:this.deduct_amount,
                    content:this.content
                }

                if(obj.save_list.length <= 0 || obj.valid_start_date == '' || obj.valid_end_date == '' || obj.deduct_amount == ''){
                    this.$message.error('请完善输入内容');return false;
                }

                this.$api.post("transaction_flow_back/save_flow_back_info",obj,res => {

                    if(res.code == 0){

                        //返回导入失败数据
                        _this.save_list = res.data
                        var is_fail_save = false//是否有失败数据 默认无失败数据
                        for(var i = 0; i < _this.save_list.length; i++){
                            if(_this.save_list[i].reason != ''){
                                _this.fail_sum = _this.fail_sum + 1;
                                is_fail_save = true // 有失败数据 失败数据会带有reason 失败原因
                            }else{
                                _this.success_sum = _this.success_sum + 1;
                            }
                        }
                        //检测是否有失败数据
                        if(is_fail_save == false){
                            _this.$message({message: '导入成功',type: 'success'});
                            setTimeout(function(){
                                _this.hide()
                            },1500)
                        }else{
                            _this.$message({ message: '部分数据导入失败',type: 'warning'});
                        }
                        //插入成功 重新拉取数据
                        _this.getFlowBackList()
                    }else{
                        _this.$message.error(res.msg);
                    }

                })
            },
            //显示弹框
            show(){
                this.is_show = true
            },
            //隐藏弹框
            hide(){
                this.is_show = false
                this.save_list = []//输入终端设备信息
                this.valid_start_date = ''//扣款开始时间
                this.valid_end_date = ''//扣款结束时间
                this.deduct_amount = ''//输入扣款金额
                this.content = ""//备注
                this.fail_save_list = []//添加失败队列
            },
            ////////////////导入数据结束


            //下载模板
            tableToExcel(){
                const jsonData = []
                // 列标题
                let str = '<tr><td>终端sn</td><td>店铺编号</td></tr>';
                // 循环遍历，每行加入tr标签，每个单元格加td标签
                for(let i = 0 ; i < jsonData.length ; i++ ){
                    str+='<tr>';
                    for(const key in jsonData[i]){
                        // 增加\t为了不让表格显示科学计数法或者其他格式
                        str+=`<td>${ jsonData[i][key] + '\t'}</td>`;
                    }
                    str+='</tr>';
                }
                // Worksheet名
                const worksheet = '模板'
                const uri = 'data:application/vnd.ms-excel;base64,';

                // 下载的表格模板数据
                const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
                    xmlns:x="urn:schemas-microsoft-com:office:excel"
                    <head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
                    <x:Name>${worksheet}</x:Name>
                    <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
                    </x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
                    </head><body><table>${str}</table></body></html>`;
                // 下载模板
                window.location.href = uri + this.base64(template);

            },
            base64(s){
                return window.btoa(unescape(encodeURIComponent(s)));
            }

        }
    };
</script>
<style>
    .bg_show{background-color:rgba(0,0,0,0.5);height:100%;width:100%;position:fixed;top:0;left:0;display:flex;justify-content:center;align-items:center;z-index:99}
    .demo-form-inline{width:100%;}
    .textarea{width:300px;}
    .upload_box{width:100px;}
    .upload_btn{color:#FFF;background-color:#409EFF;border-color:#409EFF;font-size: 12px;border-radius: 4px;display:flex;justify-content:center;align-items:center}
    .input_box{position: absolute;width:100px;height:50px}
    .upload{opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;}

    .hide{display:flex;justify-content:flex-end;align-content:center;margin-bottom:10px}
    .btn{display:flex;justify-content:center;align-content:center;margin-top:20px}
    .page_box{display:flex;justify-content:center;align-items:center;margin-top:20px}

</style>